export default "__VITE_ASSET__8b340f21__"